<ng-container *ngIf="vm$ | async as vm">
    <ms-fixture-list-header [sport]="vm.sport" [competitionTitle]="vm.title" [showFavoriteToggle]="vm.isFavouritesEnabled">
        <ms-tournament-groups *ngIf="vm.virtualCompetition" [model]="vm.virtualCompetition"></ms-tournament-groups>
    </ms-fixture-list-header>
</ng-container>
